import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { useEffect } from 'react';
import { ModuleSelect } from '@/components/core/form/ModuleSelect';

const CashPlotForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({ defaultValues });
  const { watch } = methods;

  // Canonical react-hook-form change subscription. The callback fires with
  // the latest form values on every field update; no inner handleSubmit
  // round-trip is needed because this form has no validation rules.
  // The eslint-disable matches the same pattern in other Analyze forms
  // (LCAPlotForm, CharacteristicsForm, WorkbenchTableForm).
  useEffect(() => {
    // eslint-disable-next-line react-hooks/incompatible-library
    const subscription = watch(data => onSubmit(data));
    return () => subscription.unsubscribe();
  }, [watch, onSubmit]);

  return (
    <FormProvider {...methods}>
      <div className="group node">
        <form>
          <div className="mt-2 grid grid-cols-6 gap-2">
            <ModuleSelect />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

CashPlotForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default CashPlotForm;
